jQuery(document).ready(function($) {
  const logo = $("#tytan-header-changing-logo");
  const originalLogo = logo.attr("src");
  const newLogo = ignited.template_url + "/dist/images/tytan-logo.svg";

  $(window).scroll(function() {
    if ($(this).scrollTop() > 10) {
      logo.attr("src", newLogo);
    } else {
      logo.attr("src", originalLogo);
    }
  });
});
